import { Injectable } from '@angular/core';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class CompanyTypeService extends BaseDataService {

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public GetCompanyTypes(id: number) {
        let url = `Common/GetCompanyTypes`;
        return super.getAll<any>(url);
    }

    public GetCompanyType(id: number) {
        let url = `Common/GetCompanyTypeById?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveCompanyType(data) {
        let url = `Common/SaveCompanyType`;
        return super.save<any>(url, data);
    }

    public deleteCompanyType(data) {
        let url = `Common/DeleteCompanyType`;
        return super.save<any>(url, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/company-type.service.ts